<template lang="pug">
  div.liquid-fill-chart
    div.title 公关传播效果评价
    div#liquidFillChart
    p.avg 公关传播效果评价：
      .avg {{liquidFill.interveneLevel}}
</template>

<script>
import echarts from 'echarts'
require('echarts-liquidfill')
export default {
  name: 'LiquidFillChart',
  computed: {
    liquidFill () {
      return this.$store.state.event.liquidFill
    }
  },
  watch: {
    liquidFill: {
      deep: true,
      handler () {
        this.init()
      }
    }
  },
  methods: {
    init () {
      let myChart = echarts.init(document.getElementById('liquidFillChart'))
      let data = this.liquidFill.interveneScore / 100
      let option = {
        title: {
          text: this.liquidFill.interveneScore,
          left: 'center',
          top: '20%',
          textStyle: {
            fontSize: 14,
            fontWeight: 'normal',
            color: '#3989cb'
          }
        },
        series: [
          {
            type: 'liquidFill',
            radius: '98%',
            //  shape: 'roundRect',
            data: [data],
            waveAnimation: false,
            backgroundStyle: {
              color: '#f0f8ff'
            },
            outline: {
              borderDistance: 6,
              itemStyle: {
                borderWidth: 4,
                borderColor: '#3e96de',
                shadowBlur: 0
              }
            },
            itemStyle: {
              // color: '#3989cb'
              shadowBlur: 0,
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: '#7ec2fa'
                }, {
                  offset: 1,
                  color: '#3989cb'
                }],
                global: false
              }
            },
            label: {
              normal: {
                formatter: ''
              }
            }
          }
        ]
      }
      myChart.setOption(option)
      window.addEventListener('resize', () => {
        myChart.resize()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.liquid-fill-chart {
  padding: 0 20px;
  height: 300px;
  flex: 1;

  .title {
    margin-top: 24px;
    text-align: center;
  }

  #liquidFillChart {
    margin-top: 10px;
    height: 180px;
    display: flex;
    justify-content: center;
  }

  .avg {
    text-align: center;
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventGeneral/LiquidFillChart.vue